<kendo-breadcrumb [items]="this.breadCrumb()" (itemClick)="this.onBreadCrumbClick($event)"></kendo-breadcrumb>

@if (kopConfigService.isDetail()) {
    <validation-info [validation]="this.validationService.selectedAfdValidation()" />
    <div class="module-container" dropzone="true" (dragleave)="isDropValid = false" (drop)="onModuleDrop($event)"
    (dragover)="onDragOver($event)" [class.dropzone]="isDropValid">
    @for (module of this.kopModulesService.afdModules(); track module.meta.key) {
    <module-card [afdModule]="module" (onCardClicked)="onModuleClicked($event)"></module-card>
    }
    <div class="new-container">
        <paste dialogTitle="{{'Plakken Module' | translate: 'Plakken Module'}}"/>
    </div>

</div>
<module-props [isEditing]="this.kopModulesService.isEditingModule()" [moduleKey]="this.moduleKey"
    (cancel)="onModuleEditCancel()" (apply)="onModuleEditApply($event)" />

} @else {
<div class="list-container" #afdList cdkDropList cdkDropListOrientation="mixed" (cdkDropListDropped)="onDrop($event)" >
    @for (afd of kopConfigService.afdelings(); track afd.afdeling().refNr) {
    <afd-card [afd]="afd" [selected]="afd.afdeling().refNr == kopConfigService.selectedAfd()?.afdeling()?.refNr" cdkDrag
        (onCardClicked)="onCardClicked($event, $index)"></afd-card>
    }
    <div class="new-container">
        <kendo-dropdownbutton [data]="allAfd()" (itemClick)="onNew($event)" [themeColor]="'primary'">
            {{ 'Nieuw' | translate: 'Nieuw' }}
        </kendo-dropdownbutton>
        <paste dialogTitle="{{'Plakken Afdeling' | translate: 'Plakken Afdeling'}}"/>
    </div>
    @if (this.jsBridgeService.isDev()) {
        <translation-editor />
    }
</div>

}